import React, { useContext } from "react";
import "./style.css";
import { Footer } from "./components/Footer";
import { AutoRegistrationContext } from "./context/AutoRegistrationProvider";

import logoCargill from "../../assets/images/logo.svg";
import { StepOne } from "./steps/SchedulingOne";
import useStyles from "./styles";
import { StepTwo } from "./steps/SchedulingTwo";
import { StepThree } from "./steps/SchedulingThree";

import { Box, Typography } from "@material-ui/core";
import { Initial } from "./steps/Initial";
import { ExchangeNotes } from "./steps/ExchangeNotes";

export const AutoRegistrationComponent = () => {
  const { step } = useContext(AutoRegistrationContext);
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <img src={logoCargill} alt="Logo" />
        <Typography variant="h2" className={classes.title}>
          Cadastre-se no Logar
        </Typography>
        {step === 0 && <Initial />}
        {step === 1 && <StepOne />}
        {step === 2 && <StepTwo />}
        {step === 3 && <StepThree />}
        {step === 5 && <ExchangeNotes />}
      </Box>
      <Footer />
    </Box>
  );
};
